import type { InvoiceStatus } from '../../api/invoices'
import { INVOICE_STATUS_COLORS, INVOICE_STATUS_LABELS } from '../../lib/invoiceStatus'

export function StatusBadge({ status, className = '' }: { status: InvoiceStatus; className?: string }) {
  return (
    <span className={`badge text-white ${className}`}
      style={{ backgroundColor: INVOICE_STATUS_COLORS[status] ?? '#9CA3AF' }}>
      {INVOICE_STATUS_LABELS[status] ?? status}
    </span>
  )
}
